<template>
  <v-container class="pa-0 main_lobby" fluid>
    <vendor-booth-image />
    <VendorDirectory/>
    <v-speed-dial bottom fixed class="mb-16 mr-3" right>
    <template v-slot:activator>
      <v-btn color="yellow darken-2" dark @click="showVendorDirectory">
        Vendor Directory
      </v-btn>
    </template>
    </v-speed-dial>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import VendorBoothImage from "@/components/vendor-hall/VendorBoothImage";
import VendorDirectory from "@/components/exhibitor/Directory.vue";
export default {
  components: {
    VendorBoothImage,
    VendorDirectory
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods : {
    ...mapMutations("vendor_directory", ["setVendorData"]),
    showVendorDirectory() {
      this.setVendorData({
        key: "show_vendor_directory_modal",
        data: true,
      });
    },
  }
}
</script>
<style>
.st1 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #00000040 !important;
}
</style>
